/**
 * Test Article Loader Module
 * Manages loading of different test article sets for development/testing
 */

// Import all test article sets
import testArticles from './Pdf/testArticles.js';
import testArticlesSimple from './Pdf/testArticlesSimple.js';
import testArticlesMagazine from './Pdf/testArticlesMagazine.js';
import testArticlesEducational from './Pdf/testArticlesEducational.js';
import testArticlesMixed from './Pdf/testArticlesMixed.js';
import testArticlesStress from './Pdf/testArticlesStress.js';

// Available test article sets
const TEST_ARTICLE_SETS = {
    original: testArticles,
    simple: testArticlesSimple,
    magazine: testArticlesMagazine,
    educational: testArticlesEducational,
    mixed: testArticlesMixed,
    stress: testArticlesStress,
};

/**
 * Get the appropriate test article set based on URL parameters
 * @returns {Array} Selected test article set
 */
export function getTestArticleSet() {
    const urlParams = new URLSearchParams(window.location.search);
    const articleSet = urlParams.get('test_articles') || 'original';

    if (TEST_ARTICLE_SETS[articleSet]) {
        return TEST_ARTICLE_SETS[articleSet];
    } else {
        console.warn(`[Add-ons test] Unknown test article set: ${articleSet}, falling back to original`);
        return TEST_ARTICLE_SETS.original;
    }
}

/**
 * Get list of available test article set names
 * @returns {Array<string>} Array of available set names
 */
export function getAvailableTestSets() {
    return Object.keys(TEST_ARTICLE_SETS);
}

/**
 * Default export for convenience
 */
export default getTestArticleSet;
